export const INFO_TEXT = {
  FIRST: 'Mientras tanto, tus aportes se mantendrán rentabilizados.',
  SECOND:
    'Para continuar con este ahorro tendrás que realizar una nueva suscripción, la que se materializará en 2 meses.',
  THIRD:
    'Como opción para no revocar tu ahorro, te sugerimos modificar el monto mensual.',
  FOURTH:
    'Por favor, verifica que el correo de tu empleador esté correcto, ya que le notificaremos para que realice la modificación de tu ahorro.',
};
